import type { AnalyticsEvents } from '@/types/analytics-events';

type TrackEventArgs = {
  [E in keyof AnalyticsEvents]: AnalyticsEvents[E] extends undefined
    ? [eventName: E, params?: undefined]
    : [eventName: E, params: AnalyticsEvents[E]];
}[keyof AnalyticsEvents];

// GA4 events that are also sent to the Meta Pixel: standard events where one fits, custom otherwise
const META_EVENTS: Partial<
  Record<keyof AnalyticsEvents, { command: 'track' | 'trackCustom'; name: string }>
> = {
  reservation_submit: { command: 'track', name: 'Schedule' },
  contact_submit: { command: 'track', name: 'Lead' },
  phone_click: { command: 'track', name: 'Contact' },
  order_online_click: { command: 'trackCustom', name: 'OrderOnlineClick' },
};

export const trackEvent = (...[eventName, params]: TrackEventArgs) => {
  if (typeof window === 'undefined') {
    return;
  }
  window.gtag?.('event', eventName, params);

  const metaEvent = META_EVENTS[eventName];
  if (metaEvent) {
    window.fbq?.(metaEvent.command, metaEvent.name, params);
  }
};
